module.exports = __webpack_public_path__ + "static/media/particlebois.bf1f80e7.gif";